var _path, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEmail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 14,
    viewBox: "0 0 15 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_143_4001)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_143_4001",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 15,
    height: 14
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.642822 0H14.6428V14H0.642822V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_143_4001)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.41851 3.72913C1.19005 3.5769 1.05298 3.32078 1.05298 3.04644V3.04575C1.05298 2.56076 1.44618 2.16758 1.93121 2.16758H13.3544C13.8394 2.16758 14.2326 2.56076 14.2326 3.04575V3.04619V3.04644C14.2326 3.32078 14.0956 3.5769 13.8671 3.72913C12.7523 4.47247 9.39326 6.71167 8.13022 7.55386C7.83502 7.75068 7.4506 7.75068 7.15539 7.55386C5.89233 6.71167 2.53329 4.47247 1.41851 3.72913Z",
    stroke: "black",
    strokeWidth: 1.05957,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.05298 3.04622V10.954C1.05298 11.1871 1.14546 11.4105 1.31042 11.5752C1.47517 11.7402 1.69856 11.8326 1.93162 11.8326H13.354C13.587 11.8326 13.8104 11.7402 13.9752 11.5752C14.1401 11.4105 14.2326 11.1871 14.2326 10.954V3.04622",
    stroke: "black",
    strokeWidth: 1.05957,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_143_4001"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "white",
    transform: "translate(0.642822)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmail);
export default __webpack_public_path__ + "static/media/email.bfeb560fe6a9a2df9301db11a5cfb7d2.svg";
export { ForwardRef as ReactComponent };